import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/user-list';
import ViewComponent from './components/user-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from "./components/user-form-new";
import mapByUserName from "../../import/normalize/map-user";
import CustomFieldUsersViewInImport from "../../import/view-in-preview/users-view-in-preview";

export default class UsersCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    getCsvValue(item) {
        const { customFieldsData } = item;
        let res = [];
        const usersId = !!customFieldsData[this.customField.id] ? customFieldsData[this.customField.id] : [];

        _.map(usersId, userId=>{
            const user = gd.session.users.get(userId);
            if (user) res.push(user.name);
        })

        return res.join(', ');
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort && !!i.item.customFieldsData[this.customField.id] ? i.item.customFieldsData[this.customField.id].length : 0,
            ],
            directions: [sort]
        }
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    // IMPORT

    normalizeCSVValue(values) {
        let selectedValues = values ? values.split(', ') : [];
        selectedValues = _.map(selectedValues, value=>value.toLowerCase())

        const ids = [];
        _.map(selectedValues, value=>{
            ids.push(mapByUserName(gd.companyId, value));
        })

        return ids;
    }

    getComponentViewInImport() {
        return CustomFieldUsersViewInImport;
    }
}